import React, { Component } from 'react';
import axios from 'axios';
import i18n from '../../i18n';
import Errorbar from '../common/errorbar';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

class PCStores extends Component { 
    constructor(props){
        super(props)
        this.state = {
            company:[],
            styles:{},
            errorMessage:"",
            openErrorBar:false,
            bodyMinHeight:0,
            companyName:"",
        }
    }
    
    componentWillMount = () => {
        this.getProps()
        this.getCompanyList()
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
    }

    // ページ内リンク対策
    componentDidUpdate = () => {
        if(this.state.companyName != "" ){
            var href = "/stores/#" + this.state.companyName.companyName
            window.location.href = href
            this.setState({companyName:""})
        }
    }

    // ホームページからもらったパラメータを取得する
    getProps = () => {
        if(typeof this.props.location.state != "undefined"){
            this.setState({companyName: this.props.location.state})
        }
    }

    // DBからデータを取得する
    getCompanyList = () => {
        var api = process.env.REACT_APP_ENDPOINT + 'store'
        axios.get(api)
        .then((response)=>{
            this.setState({company:response.data})
        }).catch((error)=>{
            console.log(error)
            this.handleErrorbarOpen()
            this.setState({noDataErr:true, errorMessage:i18n.t('home.server_error')})
        })
    }

    // レスポンシブデザイン
    handleResize = () =>{
        const windowHeight = window.innerHeight
        const footerHeight = 120
        if(window.innerWidth > 1366){
            const HeaderHeight = 230
            const bodyMinHeight = windowHeight - HeaderHeight - footerHeight
            this.setState({
                styles:PCstyles,
                bodyMinHeight: bodyMinHeight
            })
        }else if(window.innerWidth <= 1366 && window.innerWidth> 1024){
            const HeaderHeight = 205
            const bodyMinHeight = windowHeight - HeaderHeight - footerHeight
            this.setState({
                styles:halfHDStyles,
                bodyMinHeight: bodyMinHeight
            })
        }
    }

    // 文字の色チェンジ
    changeColorToBlue = (e) => {
        e.currentTarget.style.color = "blue"
    }
  
    changeColorToBlack = (e) => {
        e.currentTarget.style.color = "black"
    }

    //エラー版バー
    handleErrorbarOpen=()=>{
        this.setState({openErrorBar:true})
    }

    handleErrorbarClose=()=>{
        this.setState({openErrorBar:false})
    }

    // テーブルスタイル定義
    StyledTableCell = withStyles((theme) => ({
        head: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
          fontSize: this.state.styles.font,
        },
        body: {
          fontSize: this.state.styles.font,
        },
    }))(TableCell);

    StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    render(){

        // 画面左側の企業一覧作成
        var companys = this.state.company.map((item,index) => {
            var href = "/stores/#" + item.name
            return(
                <div key={index}>
                    <p style={this.state.styles.companyName}>
                        <a href={href} style={{color:"black"}} onMouseOver={this.changeColorToBlue} onMouseOut={this.changeColorToBlack}>{item.name}</a>
                    </p>
                    <br/>
                </div>
            );
        })

        // 店舗一覧テーブルのヘッダーを定義
        var tableHead = [
            <TableHead>
                <TableRow>
                    <this.StyledTableCell style={{width:"20%"}}>{i18n.t('stores.store_name')}</this.StyledTableCell>
                    <this.StyledTableCell align="left" style={{width:"17%"}}>{i18n.t('stores.phone_number')}</this.StyledTableCell>
                    <this.StyledTableCell align="left" style={{width:"38%"}}>{i18n.t('stores.address')}</this.StyledTableCell>
                    <this.StyledTableCell align="left">{i18n.t('stores.access_url')}</this.StyledTableCell>
                </TableRow>
            </TableHead>
        ];

        // 店舗一覧テーブル作成
        var stores = this.state.company.map((item,index) => {
            var comanyStores = item.storeList.map((_item,_index) => {
                // accessUrlが登録されていない場合
                if(_item.accessUrl == ""){
                    return(
                        <this.StyledTableRow key={_item.name}>
                            <this.StyledTableCell component="th" scope="row">
                                {_item.name}
                            </this.StyledTableCell>
                            <this.StyledTableCell align="left">{_item.phoneNumber}</this.StyledTableCell>
                            <this.StyledTableCell align="left">{_item.address}</this.StyledTableCell>
                            <this.StyledTableCell align="left"><p>ー</p></this.StyledTableCell>
                        </this.StyledTableRow>
                    )
                }else{
                    return(
                        <this.StyledTableRow key={_item.name}>
                            <this.StyledTableCell component="th" scope="row">
                                {_item.name}
                            </this.StyledTableCell>
                            <this.StyledTableCell align="left">{_item.phoneNumber}</this.StyledTableCell>
                            <this.StyledTableCell align="left">{_item.address}</this.StyledTableCell>
                            <this.StyledTableCell align="left"><a href={_item.accessUrl} target="_blank">{i18n.t('stores.click_to_access')}</a></this.StyledTableCell>
                        </this.StyledTableRow>
                    )
                }
            });
            // 店舗が登録されていない場合
            if(item.storeList.length == 0){
                return(
                    <div key={index}>
                        <p id={item.name} style={this.state.styles.tableTitle}>■ {item.name}</p>
                        <p style={this.state.styles.noDataMessage}>{i18n.t('stores.no_store_message')}</p>
                    </div>
                )
            }else{
                return(
                    <div key={index}>
                        <p id={item.name} style={this.state.styles.tableTitle}>■ {item.name}</p>
                        <Table style={this.state.styles.tableAera} aria-label="customized table">
                            {tableHead}
                            <TableBody>
                                {comanyStores}
                            </TableBody>
                        </Table>
                    </div>  
                )
            }
        });

        return(
            <div style={{minHeight:this.state.bodyMinHeight}}>
                <Errorbar open={this.state.openErrorBar} handleClose={this.handleErrorbarClose} message={this.state.errorMessage} />
                <div style={{position:"absolute", width:"20%"}}>
                    <div>
                        {companys}
                    </div>
                </div>
                <div style={{marginBottom:"50px"}}>
                    {stores}
                </div>
                <a href="#">
                    <button className="returnTopButton" style={this.state.styles.returnTopButton}>
                        <ArrowUpwardIcon style={{color:"black"}}/>
                    </button>
                </a>
            </div>
        )
    }
}

const PCstyles = {
    companyName: {
        margin:"5px 30%", 
        fontSize:"19px",
        fontWeight:"700",
        textDecoration:"underline"
    },
    tableTitle: {
        marginLeft:"25%", 
        marginTop:"50px", 
        fontSize:"20px"
    },
    tableAera: {
        width:"60%", 
        marginLeft:"25%"
    },
    font: 17,
    noDataMessage: {
        fontSize:"19px",
        color:"red",
        marginLeft:"25%"
    },
    returnTopButton:{
        position:"fixed", 
        bottom:"18px", 
        right:"2%", 
        height:"40px", 
        width:"40px", 
        background:"white"
    },
};

const halfHDStyles = {
    companyName: {
        margin:"5px 30%", 
        fontSize:"17px",
        fontWeight:"700",
        textDecoration:"underline"
    },
    tableTitle: {
        marginLeft:"22%", 
        marginTop:"50px", 
        fontSize:"20px"
    },
    tableAera: {
        width:"70%", 
        marginLeft:"22%"
    },
    font: 15,
    noDataMessage: {
        fontSize:"17px",
        color:"red",
        marginLeft:"22%"
    },
    returnTopButton:{
        position:"fixed", 
        bottom:"18px", 
        right:"2%", 
        height:"40px", 
        width:"40px", 
        background:"white"
    },
};

export default withRouter(PCStores);